module.exports = __webpack_public_path__ + "static/img/home_logo.ab86c79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_logo.png
// module id = tESk
// module chunks = 3